import { Phone, MessageCircle, Calendar, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { useLocale } from "@/contexts/LanguageContext";
import { labels } from "@/data/content";

export function MobileCTABar() {
  const { locale, t, getLocalizedHref } = useLocale();

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-background/95 backdrop-blur-xl border-t border-border/30 safe-area-bottom">
      <div className="grid grid-cols-4 divide-x divide-border/30">
        <a
          href="tel:+17738183020"
          className="flex flex-col items-center justify-center py-3 gap-1 text-foreground/80 hover:text-primary transition-colors"
          aria-label={t(labels.callNow)}
        >
          <Phone className="h-5 w-5" />
          <span className="text-[10px] font-medium">{locale === "es" ? "Llamar" : "Call"}</span>
        </a>
        <a
          href="https://wa.me/17738183020"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 gap-1 text-foreground/80 hover:text-primary transition-colors"
          aria-label={t(labels.whatsapp)}
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-[10px] font-medium">WhatsApp</span>
        </a>
        <Link
          to={getLocalizedHref("/contact")}
          className="flex flex-col items-center justify-center py-3 gap-1 bg-ivory-cta text-ivory-cta-foreground hover:bg-primary hover:text-primary-foreground transition-colors pulse-gold"
          aria-label={t(labels.bookConsultation)}
        >
          <Calendar className="h-5 w-5" />
          <span className="text-[10px] font-medium">{locale === "es" ? "Agendar" : "Book"}</span>
        </Link>
        <a
          href="https://office.martinez.law/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 gap-1 text-foreground/80 hover:text-primary transition-colors"
          aria-label={t(labels.clientPortal)}
        >
          <ExternalLink className="h-5 w-5" />
          <span className="text-[10px] font-medium">Portal</span>
        </a>
      </div>
    </div>
  );
}
